import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";

// import RefreshIcon from "@mui/icons-material/Refresh";
import { ArrowBackSharp, Refresh as RefreshIcon } from "@mui/icons-material";
import Logo from "../../shared/Logo/Logo";

import BrokenRookieIcon from "../../../assets/images/brokenRookie.svg";
import BrokenIntermediateIcon from "../../../assets/images/intermediate-broken.svg";
import BrokenAdvanced from "../../../assets/images/advance-broken.svg";
import cancelIcon from "../../../assets/images/icon-cancel.png";

import FooterBarcode from "../../shared/FooterBarcode/FooterBarcode";
import HeaderBarcode from "../../shared/HeaderBarcode/HeaderBarcode";

import "./MissionFailed.scss";

const MissionFailed = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [resetKey, setResetKey] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [missionTitle, setMissionTitle] = React.useState("");
  const [missionNumber, setMissionNumber] = React.useState("");

  // Check if stageFailData is available in location state
  React.useEffect(() => {
    if (!location.state?.stageFailData) {
      // If not, navigate back to the previous page
      navigate(-1);
    } else {
      const { description, missionTitle, missionNumber, resetKey } =
        location.state.stageFailData || {};
      // Set the state variables with the data from location state

      setDescription(description);
      setMissionTitle(missionTitle);
      setMissionNumber(missionNumber);
      setResetKey(resetKey);
    }
  }, [location.state, navigate]);

  const handleTryAgain = () => {
    // Reload or reset mission
    if (resetKey) {
      localStorage.removeItem(resetKey);
    }
    navigate(-1);
  };

  const handleBackToMap = () => {
    navigate("/map");
  };
  const getCoinSrc = (level) => {
    switch (level) {
      case "Rookie":
        return BrokenRookieIcon;
      case "Intermediate":
        return BrokenIntermediateIcon;
      case "Advanced":
        return BrokenAdvanced;
      default:
        return BrokenRookieIcon;
    }
  };

  return (
    <Stack className={`mission-failed-container mission-${missionNumber}`}>
      <Stack className="dotted-background">
        <Stack className="container header">
          <HeaderBarcode />
        </Stack>
        <Stack
          className="container content"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box className="notice-board">
            <Stack useFlexGap gap={4}>
              <div>
                <Box className="failed-coin-section">
                  <img
                    src={getCoinSrc(missionTitle)}
                    alt="Broken Coin"
                    className="coin-image"
                  />
                </Box>
                <Typography variant="h4" className="mission-title">
                  {`Mission ${missionNumber} - ${missionTitle}` ||
                    `Mission Failed`}
                </Typography>
                <Typography className="mission-status">FAIL</Typography>
              </div>
              <div>
                <Typography className="mission-subtitle">
                  <img
                    src={cancelIcon}
                    alt="Broken Coin"
                    className="cancel-image"
                  />
                  Try Again! You haven't secured the <span>{missionTitle}</span>{" "}
                  Coin yet.
                </Typography>

                <Typography className="mission-description">
                  <strong>Don't be discouraged:</strong>{" "}
                  <span>{description}</span>
                </Typography>
              </div>

              <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                className="action-buttons"
              >
                <Button
                  variant="contained"
                  className="btn try-again-button"
                  onClick={handleBackToMap}
                  startIcon={<ArrowBackSharp />}
                >
                  Go Back to map
                </Button>
                <Button
                  variant="contained"
                  className="btn back-to-map-button"
                  startIcon={<RefreshIcon />}
                  onClick={handleTryAgain}
                >
                  Try again
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
        <Stack className="container footer">
          <Logo />
          <FooterBarcode />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MissionFailed;
